import React from 'react';

import { Form, Grid } from '@mairistem/composants';

import { Section } from '@/components/Common';

interface CommentaireProps {
  commentaire: string;
  onChange: (
    _e: any,
    data: { name: string; value?: any; checked?: boolean },
  ) => void;
}

const Commentaire = (props: CommentaireProps) => {
  const { commentaire, onChange } = props;

  const handleCommentaireChange = React.useCallback(
    (value: string) => {
      onChange(null, {
        name: 'conventionDeclaration.commentaire',
        value,
      });
    },
    [onChange],
  );

  return (
    <Section
      data-testid="assistant-commentaire"
      title="COMMENTAIRE"
      style={{
        display: 'flex',
        justifyContent: 'start',
      }}
    >
      <Grid padded>
        <Grid.Column width={16}>
          <Grid.Row>
            <Form>
              <Form.TextArea
                data-testid="assistant-commentaire-texte"
                style={{ minHeight: '50px' }}
                rows={2}
                value={commentaire ?? ''}
                onChange={(_e, data) =>
                  handleCommentaireChange(data?.value ?? '')
                }
              />
            </Form>
          </Grid.Row>
        </Grid.Column>
      </Grid>
    </Section>
  );
};

export default Commentaire;
